import { Link } from "react-router-dom";
import { Lock, Crown, Check } from "lucide-react";
import { usePremium } from "../context/PremiumContext";

// Wrap premium-only page content. Shows an upgrade prompt when not premium.
// (On the web isPremium is always true, so this only gates inside the app.)
export default function PremiumGate({ feature, perks = [], children }) {
  const { isPremium } = usePremium();
  if (isPremium) return children;

  return (
    <div className="rounded-3xl border border-border bg-background/50 p-8 text-center backdrop-blur-md md:p-12" data-testid="premium-gate">
      <span className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/15 text-primary">
        <Lock className="h-6 w-6" />
      </span>
      <h2 className="font-serif-display text-2xl tracking-tight md:text-3xl">{feature} is a Premium feature</h2>
      <p className="font-ui mt-2 text-sm text-muted-foreground">
        Start your 3-day free trial to unlock it — cancel anytime.
      </p>
      {perks.length > 0 && (
        <ul className="mx-auto mt-6 max-w-xs space-y-2 text-left">
          {perks.map((p, i) => (
            <li key={i} className="font-ui flex items-center gap-2 text-sm">
              <Check className="h-4 w-4 text-primary" /> {p}
            </li>
          ))}
        </ul>
      )}
      <Link to="/premium" data-testid="gate-upgrade"
        className="font-ui mt-7 inline-flex items-center gap-2 rounded-full bg-primary px-7 py-3.5 text-sm font-semibold text-primary-foreground transition-transform hover:scale-[1.03]">
        <Crown className="h-4 w-4" /> Start free trial
      </Link>
    </div>
  );
}
